class Wishlist {
  static key = 'wishlist_items';

  static get() {
    try {
      const items = JSON.parse(localStorage.getItem(this.key));
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  static save(items) {
    localStorage.setItem(
      this.key,
      JSON.stringify([...new Set(items)])
    );

    window.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          items: this.get()
        }
      })
    );
  }

  static has(productHandle) {
    return this.get().includes(productHandle);
  }

  static add(productHandle) {
    const items = this.get();

    if (!items.includes(productHandle)) {
      items.push(productHandle);
      this.save(items);
    }

    return items;
  }

  static remove(productHandle) {
    let items = this.get();

    items = items.filter(
      handle => handle !== productHandle
    );

    this.save(items);

    return items;
  }

  static toggle(productHandle) {
    if (this.has(productHandle)) {
      return {
        action: 'removed',
        items: this.remove(productHandle)
      };
    }

    return {
      action: 'added',
      items: this.add(productHandle)
    };
  }

  /*
  ==============================
  PRODUCT DATA
  ==============================
  */

  static async getProduct(handle) {
    try {
      const response = await fetch(
        `/products/${encodeURIComponent(handle)}.js`
      );

      if (!response.ok) {
        throw new Error('Product not found');
      }

      return await response.json();

    } catch (error) {
      console.error(
        'Wishlist product fetch error:',
        error
      );

      return null;
    }
  }

  /*
  ==============================
  GTM / GA4 TRACKING
  ==============================
  */

  static track(eventName, product = null, extra = {}) {
    window.dataLayer = window.dataLayer || [];

    const data = {
      event: eventName,
      wishlist_count: this.get().length,
      ...extra
    };

    if (product) {
      data.ecommerce = {
        items: [
          {
            item_id:
              String(product.id || ''),

            item_name:
              product.title || '',

            item_brand:
              product.vendor || '',

            item_category:
              product.type || '',

            item_variant:
              product.variants?.[0]?.title || '',

            price:
              product.price
                ? product.price / 100
                : undefined,

            quantity: 1,

            item_list_name:
              'Wishlist'
          }
        ]
      };
    }

    window.dataLayer.push(data);

    /*
    Useful for debugging
    Remove later if required.
    */

    console.log(
      '[Wishlist Tracking]',
      data
    );
  }

  /*
  ==============================
  TRACK ADD / REMOVE
  ==============================
  */

  static async trackToggle(
    handle,
    action,
    source
  ) {

    const product =
      await this.getProduct(handle);

    this.track(
      action === 'added'
        ? 'add_to_wishlist'
        : 'wishlist_remove',
      product,
      {
        product_handle: handle,
        wishlist_source: source || 'unknown'
      }
    );
  }

  /*
  ==============================
  UPDATE HEART BUTTONS
  ==============================
  */

  static updateButtons() {
    const items = this.get();

    document
      .querySelectorAll(
        '.wishlist-btn, .related-cushion-wishlist, [data-wishlist-button]'
      )
      .forEach(btn => {

        const handle =
          btn.dataset.handle;

        if (!handle) return;

        const active =
          items.includes(handle);

        btn.classList.toggle(
          'active',
          active
        );

        btn.classList.toggle(
          'is-active',
          active
        );

        btn.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );

        btn.setAttribute(
          'aria-label',
          active
            ? 'Remove from wishlist'
            : 'Add to wishlist'
        );

      });
  }

  /*
  ==============================
  UPDATE HEADER COUNT
  ==============================
  */

  static updateCount() {
    const items = this.get();

    document
      .querySelectorAll(
        '.wishlist-count, [data-wishlist-count]'
      )
      .forEach(countEl => {

        countEl.textContent =
          items.length;

        countEl.classList.toggle(
          'hidden',
          items.length === 0
        );

      });
  }

  static refresh() {
    this.updateButtons();
    this.updateCount();
  }
}


/*
================================
GLOBAL WISHLIST BUTTON CLICK
================================
*/

document.addEventListener(
  'click',
  function (event) {

    const btn =
      event.target.closest(
        '.wishlist-btn, .related-cushion-wishlist, [data-wishlist-button]'
      );

    if (!btn) return;

    /*
    Don't process special wishlist-page
    remove buttons here.
    */

    if (
      btn.hasAttribute(
        'data-wishlist-page-remove'
      )
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const handle =
      btn.dataset.handle;

    if (!handle) return;

    /*
    Determine source
    */

    let source =
      btn.dataset.wishlistSource;

    if (!source) {

      if (
        btn.closest(
          '.product-card-wrapper, .card-wrapper'
        )
      ) {
        source = 'collection_card';

      } else if (
        document.body.classList.contains(
          'template-product'
        )
      ) {
        source = 'product_page';

      } else {
        source = 'other';
      }

    }

    const result =
      Wishlist.toggle(handle);

    Wishlist.refresh();

    Wishlist.trackToggle(
      handle,
      result.action,
      source
    );

  }
);


/*
================================
WHEN WISHLIST UPDATED
================================
*/

window.addEventListener(
  'wishlist:updated',
  function () {
    Wishlist.refresh();
  }
);


/*
================================
INITIALIZE
================================
*/

document.addEventListener(
  'DOMContentLoaded',
  function () {
    Wishlist.refresh();
  }
);


/*
Make globally accessible
*/

window.Wishlist = Wishlist;